module.exports = __webpack_public_path__ + "static/logo-249103d2236af70186e4559bcbb38223.png";